import moment from 'moment'
const { fetcher } = require('services/helpers/responseHandler')

const getMessages = async kind => fetcher.get(`content/campaign/custom/list?kind=${kind}`)

const sendTestMessage = async ({
  audience,
  sendExactlyOn = null,
  messageTemplate,
  mediaUrls = [],
  promotionCode,
  minNightsToStay,
  promotionTagline,
  maxDiscountPercentage,
  promoValidityStartDate,
  promoValidityEndDate,
  hasPromoValidityDate
}) =>
  fetcher.post(`content/announcement/test`, {
    kind: audience,
    sendExactlyOn,
    details: {
      messageTemplate,
      deliveryName: `${audience} - ${moment(sendExactlyOn).format('MMM DD, YYYY')}`,
      messageMediaUrls: mediaUrls,
      promotionCode,
      minNightsToStay,
      promotionTagline,
      maxDiscountPercentage,
      promoValidityStartDate,
      promoValidityEndDate,
      hasPromoValidityDate
    }
  })

const add = async ({
  audience,
  sendExactlyOn = null,
  messageTemplate,
  mediaUrls = [],
  promotionCode,
  minNightsToStay,
  promotionTagline,
  maxDiscountPercentage,
  promoValidityStartDate,
  promoValidityEndDate,
  hasPromoValidityDate
}) =>
  fetcher.post(`content/campaign/announcement/add`, {
    kind: audience,
    sendExactlyOn,
    details: {
      messageTemplate,
      messageMediaUrls: mediaUrls,
      promotionCode,
      minNightsToStay,
      promotionTagline,
      maxDiscountPercentage,
      promoValidityStartDate,
      promoValidityEndDate,
      hasPromoValidityDate
    }
  })

const addRecurring = async ({
  audience,
  sendExactlyOn = null,
  messageTemplate,
  mediaUrls = [],
  repeatCount
}) => {
  const promisesArray = Array(repeatCount)
    .fill(null)
    .map((_, i) =>
      add({
        audience,
        sendExactlyOn: moment(sendExactlyOn).add(i, 'weeks').format('YYYY-MM-DD h:mm A'),
        messageTemplate,
        mediaUrls
      })
    )

  return Promise.all(promisesArray)
}

const getAudiences = async () => fetcher.get('audiences/inhouse')

const getDefaultText = async ({ audience }) =>
  fetcher.get('content/announcements/defaultTextContent', { kind: audience })

const announcementApi = {
  getMessages,
  getAudiences,
  add,
  addRecurring,
  getDefaultText,
  sendTestMessage
}

export default announcementApi
